import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { BehaviorSubject, EMPTY, Subject } from "rxjs";
import { ILocationService } from "angular";
import { catchError, filter, startWith, switchMap, takeUntil, tap } from "rxjs/operators";
import { FileAttachmentService } from "ng/src/app/notes/shared/file-attachments/file-attachment.service";
import { Nullable } from "ng/src/app/shared/model/app.model";
import { FileAttachment } from "ng/src/app/notes/shared/file-attachments/file-attachment.model";
import { FileDetailPreviewStyle, FileDetailType } from "ng/src/app/files/file-details/file-details.model";
import { ConfirmationService } from "primeng/api";
import { LogBookRootScopeService } from "app/shared/model/app.model";

@Component({
	template: `
		<lb-file-details *ngIf="file" [file]="file" [previewStyles]="styles"></lb-file-details>
		<p-confirmDialog></p-confirmDialog>
	`,
	selector: 'lb-files',
})
export class FilesComponent implements OnInit, OnDestroy {
	
	file: FileAttachment | null = null;
	styles: FileDetailPreviewStyle = {
		[FileDetailType.Type.PDF]: { height: 'calc(100vh - 240px)', minHeight: '650px' }
	}
	
	private fileIdSubject = new BehaviorSubject<number | null>(null);
	private onDestroy$ = new Subject();
	
	constructor(
		private fileService: FileAttachmentService,
		private confirmationService: ConfirmationService,
		@Inject('$location') private $location: ILocationService,
		@Inject('$rootScope') private $rootScope: LogBookRootScopeService
	) {}
	
	ngOnInit(): void {
		this.fileIdSubject.pipe(
			takeUntil(this.onDestroy$),
			switchMap((fileId) => {
				if (fileId == null || isNaN(fileId))
					return EMPTY.pipe(startWith(null));
				
				return this.fileService.getFileAttachment(fileId!)
					.pipe(
						catchError(err => EMPTY.pipe(startWith(null))),
						tap(fa => {
							if (!fa) this.displayFileNotFound();
							return !!fa;
					}));
			}),
				filter((fa: Nullable<FileAttachment>) => (typeof fa?.id === 'number'))
			)
			.subscribe((fa) => {
				this.file = fa;
				this.$rootScope.title = fa?.filename ?? 'Files';
			});
		
		this.updateFile();
	}
	
	ngOnDestroy(): void {
		this.onDestroy$.next();
	}
	
	private displayFileNotFound() {
		this.confirmationService.confirm({
			header: 'File not found',
			message: 'The specified file was not found.',
			rejectLabel: 'Dismiss',
			reject: () => this.$location.path('/notes').search('fileId', null),
			rejectIcon: 'p-d-none',
			acceptVisible: false,
		})
	}
	
	private updateFile() {
		const fileId = parseInt(this.$location.search()['fileId']);
		if (isNaN(fileId)) {
			this.displayFileNotFound();
		}
		this.fileIdSubject.next(fileId);
	}
}